import ZkMenuItem from '../menu/src/menu-item';

/* istanbul ignore next */
ZkMenuItem.install = function(Vue) {
  Vue.component(ZkMenuItem.name, ZkMenuItem);
};

export default ZkMenuItem;



// WEBPACK FOOTER //
// ./src/packages/menu-item/index.js